import api from "../services/api";

function initAnalyticEventListeners() {
  const elements = document.querySelectorAll("[analytic-event]") as NodeListOf<HTMLElement>;

  elements.forEach((element) => {
    const eventName = element.getAttribute("analytic-event");

    if (eventName) {
      const eventDataString = element.getAttribute("analytic-event-data");
      const eventData = eventDataString ? JSON.parse(eventDataString) : {};

      eventData["page_url"] = window.location.href;

      element.addEventListener("click", () => {
        api.logEvent(eventName, eventData);
      });
    } else {
      console.warn("Event name not specified for element", element);
    }
  });
}

document.addEventListener("DOMContentLoaded", initAnalyticEventListeners);
